module.exports = __webpack_public_path__ + "static/media/ALIANZA BRA-21.6feb77e5.png";